// extracted by mini-css-extract-plugin
export default {"container":"CheckIcon_container__64cer"};